import useBaseData from './useBaseData';
import { ensureOptionArray } from '../types/Option';

export default function useTariffs() {
  return ensureOptionArray(useBaseData().cruise?.tariffs);
}
